<!-- 民宿酒店详情页  mjs -->
<template>
 <div class="travelServe homestayhoteldetailContainer">
    <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">民宿酒店</a>
        <span>&gt;</span>
        <a href="#">详情页</a>
      </div>
    </div> -->
<crumbs detail="true"/>
    <div class="container">
      <div class="leftPart pb100 fl">

      <div class="Cleft1" style="width:100% !important;">
        <div class="dtop1" style="width:100% !important;">
            <div class="content clearfix">
                <!--banner-->
                <!--desc-->
                <div class="desc">
                    <div class="ditemtxt clearfix">
                        <div class="ditemtxtlf">
                            <div class="title ">
                                <h2>{{detailInfo.name}}</h2>
                            </div>
                            <div class="translate">{{detailInfo.enName}}</div>
                            <div class="itemlist" v-for="(item,i) in labelList" :key="i" >
                                <div class="tab">{{item.dictName}}</div>
                            </div>
                        </div>
                        <div class="ditemtxtrg ">
                            <div class="price" v-if="detailInfo.price !== undefined && detailInfo.price !== ''">￥<i>{{detailInfo.price}}</i>起</div>
                            <div class="itemfun clearfix">
                                <a :href="detailInfo.link" class="buylink" target="_blank">立即预定</a>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <div class="itemaddress">
                            <div class="adlf">
                                <i></i>地址：{{detailInfo.address}}
                            </div>

                            <div class="adrg">
                              <pv :pvtype=1 :count=pv></pv>
                                <!-- <span class="browsevalue">
                                    <i></i>
                                    <b>110</b>
                                </span>
                                <span class="praisevalue">
                                  <i></i>
                                  <b>110</b>
                                </span>
                                <span class="collectvalue">
                                    <i></i>
                                    <b>0111</b>
                                </span> -->
                            </div>
                        </div>
                        <div class="itemimages">
                           <img v-for="(val,index) in images" :key="index + 'as'" preview="0" :src="getImage(val)"  alt="">
                        </div>
                    </div>

                </div>
            </div>
            <div class="dbttom" v-if="hotelFacilityList && hotelFacilityList.length > 0">
                <div class="title"><span>设施服务</span><i></i></div>
                <div class="sevice">
                        <div class="seviceItem" v-for="(demo,j) in hotelFacilityList"  :key="j">
                           <img :src="getImage(demo.image)"  alt="">
                            <div>{{demo.dictName}}</div>
                        </div>
                   <div class="clearfix"></div>
                </div>
            </div>
            <div class="dbttom" v-if="detailInfo.departureTime !== undefined && detailInfo.petCarry !== undefined && detailInfo.decorateTime !== undefined
&& detailInfo.openingHours !== undefined && detailInfo.floorHeight !== undefined && detailInfo.roomCapacity !== undefined">
                <div class="title"><span>订房必读</span><i></i></div>
                <div class="mustRead">
                    <p v-if="detailInfo.departureTime !== '' && detailInfo.departureTime !== undefined"><span>入离时间:</span>{{detailInfo.departureTime}}</p>
                    <p v-if="detailInfo.petCarry !== '' && detailInfo.petCarry !== undefined"><span>宠物携带:</span>{{detailInfo.petCarry}}</p>
                    <p v-if="detailInfo.decorateTime !== '' && detailInfo.decorateTime !== undefined"><span>装修时间:</span>{{detailInfo.decorateTime}}</p>
                    <p v-if="detailInfo.openingHours !== '' && detailInfo.openingHours !== undefined"><span>开业时间:</span>{{detailInfo.openingHours}}</p>
                    <p v-if="detailInfo.floorHeight !== '' && detailInfo.floorHeight !== undefined"><span>楼层高度:</span>{{detailInfo.floorHeight}}</p>
                    <p v-if="detailInfo.roomCapacity !== '' && detailInfo.roomCapacity !== undefined"><span>客房容量:</span>{{detailInfo.roomCapacity}}</p>
                </div>
            </div>
            <div class="dbttom">
                <div class="title"><span>酒店介绍</span><i></i></div>
                <div class="contentbox" v-html="detailInfo.content">

                </div>
            </div>
        </div>
        <!-- 评论 组件引入 -->
        <comment v-if="detailInfo" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
    </div>

      </div>

      <!-- 右侧 -->
      <div class="rightPart fr">
       <div class="Cright">
        <h2 class="titleMore"><span>相关推荐</span> <a href="javascript:;" @click="goHotelList">更多></a></h2>
        <ul class="recommend">
            <li class="item ditemtxtlf" @click.stop="gotodetail(val.id)" v-if="val.id != id" v-for="(val) in hotelList" :key="val.id">
                <div class="itemImg">
                  <img :src="getImage(val.image)"  alt="">
                </div>
                <div class="itemdes">
                    <div class="title clearfix">
                        <h2>{{val.name}}</h2>
                        <span>￥<i>{{val.price}}</i>起</span>
                    </div>
                    <div class="translate">{{val.enName}}</div>
                </div>
                    <div class="itemlist">
                       <div class="tab" v-if="val.labelarr.length !== 0"  v-for="(vals,i) in val.labelarr"
              :key="'a'+ i">{{vals.dictName}}</div>
                       <div class="clearfix"></div>
                    </div>

                <div class="values clearfix" >
                      <span class="browsevalue">
                  <i></i>
                  <b>{{val.pv}}</b>
                </span>
                <span class="praisevalue">
                    <star
                      class="star"
                        starStyle="iconstar1"
                        :isSelect="val.isStar"
                        :count="val.star"
                        :menu-id="menuId"
                        :business-id="val.id"
                        @changecount="changePraise"
                      ></star>
                </span>
                <span class="collectvalue" >
                <collect
                  collect-style="iconcollect1"
                  :is-select="val.isCollect"
                  :count="val.collect"
                  @changecount="changeCollect"
                  :menu-id="menuId"
                  :business-id="val.id"
                  ></collect>
                </span>
                </div>

            </li>
        </ul>

    </div>

      </div>
       <right-sidebar @pvcount="pvcount" :comment-count="commentTotal" :comment-gotop="commentOffsettop" :comment-show="isCommentshow" ref="rightSidebar"
        :title="detailInfo.name"
        :image="getImage(detailInfo.image)"
        :url="this.$route.fullPath"
       ></right-sidebar>
        <go-top></go-top>
    </div>

 </div>
</template>

<script>
import { getTypeList } from '@/api/typescreen/index'
import pv from '@/components/amount/pv'
import star from '@/components/amount/star'
import collect from '@/components/amount/collect'
import crumbs from '@/components/crumbs/index'
import {gethotelDetail, getHomestayhotelList} from '@/api/homestayhotel/index'
import {getListAmount} from '@/api/datavolume/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
export default {
  name: 'homestayhoteldetail',
  components: {
    Comment,
    RightSidebar,
    goTop,
    crumbs,
    pv,
    star,
    collect
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      appointment: 'mjs',
      commentId: 0,
      id: '',
      detailInfo: {},
      images: [],
      isCommentshow: true,
      commentTotal: '',
      commentOffsettop: '',
      pv: 0,
      typeParams: {
        menuId: '',
        dictParentCode: 'hotelLabel,hotelFacilityService'
      },
      codeLabel: [],
      codehotelFacilit: [],
      labelList: [],
      hotelFacilityList: [],
      homestayhotelparam: {
        menuId: '',
        pageNum: 1,
        pageSize: 5,
        areaType: '',
        hotelType: '',
        hotelLabel: '',
        facilityService: '',
        customTypeId: ''
      },
      hotelList: [],
      menuId: ''
    }
  },
  created () {
    this.id = this.$route.query.id
    this.typeParams.menuId = this.$route.query.columnId
    this.homestayhotelparam.menuId = this.$route.query.columnId
    this.menuId = this.$route.query.columnId
    this.phoneNum = this.$cookie.get('wlymobilephone')
    this.getdetail()
    this.getType()
    this.getHotelList()
    // this.dodata()
  },
  mounted () {

  },
  methods: {
    getHotelList () {
      getHomestayhotelList(this.homestayhotelparam).then(res => {
        console.log(res.data, 'mjs')
        this.total = res.data.data.total
        if (this.total === 0) {
          this.nodataflag = true
        } else {
          this.nodataflag = false
        }
        // this.hotelList = res.data.data.rows
        let that = this
        const params = {
          p: this.$cookie.get('wlymobilephone')
        }
        getListAmount(this.menuId, params).then(res1 => {
          res1.data.data.forEach(item => {
            res.data.data.rows.forEach((val, index) => {
              if (item.dataId === val.id) {
                let servearr = []
                let labelarr = []
                getTypeList(this.typeParams).then(val1 => {
                  let service = val1.data.data.dictType.hotelFacilityService.list
                  let labels = val1.data.data.dictType.hotelLabel.list
                  console.log(service, labels)

                  for (let i = 0; i < service.length; i++) {
                    if (val.facilityServiceBinkList[index] === service[i].dictCode) {
                      servearr.push(service[i])
                      console.log(service[i])
                    }
                  }
                  for (let i = 0; i < labels.length; i++) {
                    if (val.labelBinkList[index] === labels[i].dictCode) {
                      labelarr.push(labels[i])
                      console.log(labels[i])
                    }
                  }
                })

                let obj = {
                  pv: item.pv,
                  star: item.star,
                  collect: item.collect,
                  isCollect: item.isCollect,
                  isStar: item.isStar
                }
                let newObj = {...val, ...obj, servearr, labelarr}
                that.hotelList.push(newObj)
              }
            })
          })
        })
      })
    },
    changeCollect (val) {
      this.hotelList.forEach(item => {
        if (item.id === val.id) {
          item.collect = val.count
          item.isCollect = val.isSelect
        }
      })
    },
    changePraise (val) {
      this.hotelList.forEach(item => {
        if (item.id === val.id) {
          item.star = val.count
          item.isStar = val.isSelect
        }
      })
    },

    getType () {
      getTypeList(this.typeParams).then(res => {
        console.log(res, 'type')
        // res.data.data.dictType.hotelFacilityService
        // res.data.data.dictType.hotelLabel
        let service = res.data.data.dictType.hotelFacilityService.list
        let labels = res.data.data.dictType.hotelLabel.list
        console.log(service, labels)
        for (let i = 0; i < service.length; i++) {
          for (let j = 0; j < this.codehotelFacilit.length; j++) {
            if (this.codehotelFacilit[j] === service[i].dictCode) {
              this.hotelFacilityList.push(service[i])
            }
          }
        }
        for (let i = 0; i < labels.length; i++) {
          for (let j = 0; j < this.codeLabel.length; j++) {
            if (this.codeLabel[j] === labels[i].dictCode) {
              this.labelList.push(labels[i])
            }
          }
        }
      })
    },
    getdetail () {
      gethotelDetail(this.id).then(res => {
        console.log(res)
        this.detailInfo = res.data.data
        this.codeLabel = res.data.data.labelBinkList
        this.codehotelFacilit = res.data.data.facilityServiceBinkList
        this.images = res.data.data.images.split('|')
      })
    },
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    /* 浏览量 */
    pvcount (val) {
      this.pv = val
    },
    gotodetail (id) {
      this.$router.push({
        path: '/homestayhoteldetail',
        query: {
          id: id,
          columnId: this.menuId
        }
      })
    },
    goHotelList () {
      this.$router.push({
        path: '/homstayhotel',
        query: {
          columnId: this.typeParams.menuId
        }
      })
    }

  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import "../../assets/common/scss/travleServes.scss";

.alpraised i{
   background: url('~@/assets/common/icon/icon-group2.png') no-repeat !important;
   background-position: -64px 0px !important;
}
.alcollected i{
   background: url('~@/assets/common/icon/icon-group2.png') no-repeat !important;
   background-position: -64px -64px !important;
}
.collectvalue,.praisevalue{
  padding-top: 5px;
}

</style>



// WEBPACK FOOTER //
// src/view/homestayhotel/detail.vue